export const gs = {
  // Page wrapper
  page: "p-4 md:p-6 w-full",

  // Typography — brighter whites, less gray
  h1: "font-display text-3xl md:text-4xl font-bold text-gray-50 tracking-tight",
  h2: "font-display text-2xl md:text-3xl font-semibold text-gray-50 tracking-tight",
  h3: "font-display text-xl font-semibold text-gray-50",
  h4: "font-display text-lg font-semibold text-gray-50",
  body: "text-sm md:text-base text-gray-200",
  small: "text-xs md:text-sm text-gray-300",
  mono: "font-mono text-sm text-gray-100",
  label:
    "block text-[10px] font-bold text-gray-300 uppercase tracking-widest mb-1.5",
  error: "text-xs text-red-500 mt-1.5 flex items-center gap-1",

  // Flex
  flexBetween: "flex items-center justify-between",
  flexCenter: "flex items-center justify-center",
  flexStart: "flex items-center gap-3",

  // Grids
  gridCols2: "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5",
  gridCols3: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5",
  gridCols4: "grid grid-cols-2 md:grid-cols-4 gap-4",

  // Cards — lighter borders, slightly lighter bg
  card: "bg-card rounded-2xl p-4 md:p-5 border border-gray-700/60 shadow-card",
  cardSm: "bg-card rounded-xl p-4 border border-gray-700/60",
  cardHover:
    "bg-card rounded-2xl p-4 md:p-5 border border-gray-700/60 hover:border-primary/50 transition-all duration-200 cursor-pointer shadow-card",
  cardGlow:
    "bg-card rounded-2xl p-4 md:p-5 border border-primary/40 shadow-glow",

  // Buttons — brighter
  btnPrimary:
    "inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark text-[var(--on-primary)] font-display font-bold py-2.5 px-5 rounded-xl transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed text-sm tracking-wide shadow-glow-sm hover:shadow-glow",
  btnSecondary:
    "inline-flex items-center justify-center gap-2 bg-gray-700 hover:bg-gray-600 text-gray-50 font-display font-semibold py-2.5 px-5 rounded-xl transition-all duration-200 text-sm",
  btnOutline:
    "inline-flex items-center justify-center gap-2 border border-primary/60 text-primary hover:bg-primary/15 font-display font-semibold py-2.5 px-5 rounded-xl transition-all duration-200 text-sm",
  btnGhost:
    "inline-flex items-center justify-center gap-2 text-gray-300 hover:text-gray-50 hover:bg-gray-800 font-semibold py-2 px-4 rounded-lg transition-all duration-200 text-sm",
  btnDanger:
    "inline-flex items-center justify-center gap-2 bg-red-500/20 hover:bg-red-500/30 text-red-500 border border-red-500/40 font-semibold py-2.5 px-5 rounded-xl transition-all duration-200 text-sm",

  // Forms — more visible borders
  input:
    "w-full bg-gray-900/80 border border-gray-600/60 rounded-xl px-4 py-3 text-gray-50 placeholder-gray-500 focus:outline-none focus:border-primary/70 focus:bg-gray-900 transition-all text-sm",
  inputError:
    "w-full bg-gray-900/80 border border-red-500/70 rounded-xl px-4 py-3 text-gray-50 focus:outline-none focus:border-red-500 transition-all text-sm",
  select:
    "w-full bg-gray-900/80 border border-gray-600/60 rounded-xl px-4 py-3 text-gray-50 focus:outline-none focus:border-primary/70 transition-all text-sm appearance-none cursor-pointer",

  // Badges — more saturated
  badgeSuccess:
    "px-2.5 py-0.5 bg-up/20 text-up rounded-full text-[10px] font-bold tracking-wider",
  badgeWarning:
    "px-2.5 py-0.5 bg-yellow-500/20 text-yellow-600 rounded-full text-[10px] font-bold tracking-wider",
  badgeError:
    "px-2.5 py-0.5 bg-red-500/20 text-red-500 rounded-full text-[10px] font-bold tracking-wider",
  badgeInfo:
    "px-2.5 py-0.5 bg-blue-500/20 text-blue-600 rounded-full text-[10px] font-bold tracking-wider",
  badgeGray:
    "px-2.5 py-0.5 bg-gray-700 text-gray-200 rounded-full text-[10px] font-bold tracking-wider",

  // Table — brighter text, more visible borders
  tableWrapper: "w-full overflow-x-auto",
  table: "w-full text-left",
  thead: "border-b border-gray-700/60",
  th: "px-4 py-3 text-[10px] font-bold text-gray-400 uppercase tracking-widest whitespace-nowrap",
  td: "px-4 py-3.5 text-sm text-gray-200 border-b border-gray-700/30 whitespace-nowrap",
  tr: "hover:bg-gray-900 transition-colors duration-100",

  // Misc
  statCard: "bg-card rounded-xl p-4 border border-gray-700/50",
  statValue: "font-display text-2xl font-bold text-gray-50",
  statLabel: "text-[10px] text-gray-400 uppercase tracking-widest mt-1",
  divider: "w-full h-px bg-gray-700/50 my-4",
  priceUp: "text-up font-mono font-semibold",
  priceDown: "text-down font-mono font-semibold",
};
